import { Component, OnDestroy } from "@angular/core";
import { OverlayContainerService } from "app/core/services/overlay-container.service";
import { CdkPortalOutlet, Portal } from "@angular/cdk/portal";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NgForOf } from "@angular/common";

@Component({
  selector: "overlay-container",
  templateUrl: "./overlay-container.component.html",
  imports: [NgForOf, CdkPortalOutlet],
})
export class OverlayContainerComponent implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public templatePortals: Portal<any>[] = [];

  constructor(overlayContainerService: OverlayContainerService) {
    overlayContainerService.onPush$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Portal<any>) => {
        this.templatePortals.push(data);
      });

    overlayContainerService.onPop$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.templatePortals.pop();
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
